import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { isFailure } from './api/errors';
import { applyTheme, readTheme } from './app/theme';
import { watchPhone } from './app/phone';
import { router } from './app/router';
// Archivo, served from the gateway's own origin with the build (FRONTEND-AUDIT
// A7): a font fetched from Google sent every reader's address to a US origin
// on every load, and the interface talks to nothing but the gateway (ADR-0070).
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import './ui/tokens.css';

applyTheme(readTheme());
watchPhone();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A refusal is an answer. Retrying a 403 asks the same question of the
      // same rule; retrying a 401 delays the sign-in the person needs.
      retry: (count, error) => !isFailure(error) && count < 2,
      staleTime: 15_000,
      refetchOnWindowFocus: true,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
